import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import { UnifiedPrivacy } from '@prezi/presentation-service-client';
import { SocialMediaButton, SocialNetwork } from '@prezi/viewer-common';
import { viewLinkActions } from '../../../store/actions/viewLinkActions';
import * as Atoms from '../../atoms';
import * as Molecules from '../';
import { localI18n } from '../../../i18n';
const uxCopyTooltip = {
  title: localI18n._("Sharing is disabled"),
  body: localI18n._("To enable, please change the access setting to \u201CAnyone with the link can view\u201C from the dropdown.")
};
const Container = styled(Atoms.Dumb.ColumnGrid).withConfig({
  displayName: "SocialSharing__Container",
  componentId: "sc-1shz01q-0"
})(["column-gap:16px;", " a{margin:0;}"], p => p.disabled && css(["opacity:0.4;filter:grayscale(1);a{cursor:not-allowed;}"]));
const SocialSharing = () => {
  const dispatch = useDispatch();
  const containerRef = React.useRef(null);
  const canSocialShare = useSelector(state => {
    var _state$unifiedPrivacy;
    return ((_state$unifiedPrivacy = state.unifiedPrivacy.value) === null || _state$unifiedPrivacy === void 0 ? void 0 : _state$unifiedPrivacy.unified_privacy) === UnifiedPrivacy.unified_privacy.OPEN;
  });
  const document = useSelector(state => state.document.value);
  const viewLink = useSelector(state => {
    var _state$unifiedPrivacy2, _state$unifiedPrivacy3;
    return ((_state$unifiedPrivacy2 = state.unifiedPrivacy.value) === null || _state$unifiedPrivacy2 === void 0 ? void 0 : _state$unifiedPrivacy2.view_link) || ((_state$unifiedPrivacy3 = state.unifiedPrivacy.value) === null || _state$unifiedPrivacy3 === void 0 ? void 0 : _state$unifiedPrivacy3.default_link);
  });
  const [isTooltipOpen, setTooltipOpen] = React.useState(false);
  return document ? React.createElement(React.Fragment, null, React.createElement(Container, {
    ref: containerRef,
    disabled: !canSocialShare,
    onMouseEnter: () => !canSocialShare && setTooltipOpen(true),
    onMouseLeave: () => !canSocialShare && setTooltipOpen(false)
  }, Object.values(SocialNetwork).map((network, index) => React.createElement(SocialMediaButton, {
    logSocialShare: network => dispatch(viewLinkActions.logSocialShare(network)),
    title: document.title,
    tags: document.tags ? document.tags.map(tag => tag.text) : [],
    network: network,
    oid: document.oid,
    key: index,
    viewUrl: viewLink,
    size: {
      width: '18',
      height: '18'
    },
    disabled: !canSocialShare
  }))), React.createElement(Molecules.Dumb.Tooltip, {
    isOpen: isTooltipOpen,
    triggerRef: containerRef,
    uxCopy: uxCopyTooltip
  })) : null;
};
export default SocialSharing;